export const COMPLAINT_TAB_VALUES = ["submit", "history"] as const;
export type ComplaintTab = (typeof COMPLAINT_TAB_VALUES)[number];

export const isComplaintTab = (value: string | null): value is ComplaintTab =>
  Boolean(value && COMPLAINT_TAB_VALUES.includes(value as ComplaintTab));
